var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      value: _vm.value,
      options: _vm.cities,
      customMultiStyleParent: _vm.getcontainerStyle,
      loading: _vm.$apollo.queries.cities.loading,
      noOptionsText: "Start typing",
      placeholder: "City",
    },
    on: { search: (v) => (_vm.citySearchString = v), input: _vm.handleInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }